import React from "react"
import { RenderElementProps } from "slate-react"

const CopytextLarge = ({ children, attributes }: RenderElementProps) => {
    return (
        <p {...attributes} className="mb-4 text-md last:mb-0 sm:mb-5 sm:text-lg lg:text-xl">
            {children}
        </p>
    )
}

export default CopytextLarge
